import { HRRBankAccount } from '../../../../types'

export const renderLicensesList = (sales: HRRBankAccount['showSalesRetail']) =>
  sales.licenses.map((license, i) => (
    <span key={i}>
      {license.licenseNumber}
      {i === sales.licenses.length - 1 ? '' : ', '}
    </span>
  ))
